import { DSModal } from "@components/design-system/organisms";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const DeleteSessionModal = ({
  shouldShow,
  hideModal,
  confirmAction,
  isLoading = false,
}) => {
  return (
    <DSModal
      isOpen={shouldShow}
      onClose={hideModal}
      title="Delete Chat"
      dataTestId="delete-session-modal"
      actions={[
        {
          label: "Cancel",
          variant: "cancel",
          onClick: hideModal,
        },
        {
          label: isLoading ? "Deleting..." : "Delete Chat",
          variant: "primary",
          onClick: confirmAction,
          disabled: isLoading,
        },
      ]}
    >
      <div className="mb-4">
        <div className="flex items-center mb-3">
          <div className="shrink-0">
            <FontAwesomeIcon
              icon={faTrash}
              className="text-red-600"
            />
          </div>
          <div className="ml-3">
            <b className="dark:text-white">
              Are you sure you want to delete this chat session?
            </b>
          </div>
        </div>

        <p>
          This action cannot be undone. All messages and attachments
          associated with this chat session will be permanently
          deleted.
        </p>
      </div>
    </DSModal>
  );
};

export default DeleteSessionModal;
